import Vue from 'vue'
import { createClient } from 'contentful'
import store from '../services/store'

const HELPER_DIRECTIONS_CLASSES = {
  'top': 'tooltip-top',
  'topLeft': 'tooltip-top-left',
  'topRight': 'tooltip-top-right',
  'left': 'tooltip-left',
  'right': 'tooltip-right',
  'bottom': 'tooltip-bottom',
  'bottomRight': 'tooltip-bottom-right',
  'bottomLeft': 'tooltip-bottom-left'
}
const HELPER_SIZES_CLASSES = {
  'small': 'tooltip-300',
  'medium': 'tooltip-450',
  'large': 'tooltip-600',
  'xlarge': 'tooltip-700'
}

function createTooltipHtml (text, direction, size) {
  let directionClass = HELPER_DIRECTIONS_CLASSES[direction]
  let sizeClass = HELPER_SIZES_CLASSES[size]

  let html = document.createElement('div')
  html.setAttribute('role', 'tooltip')
  html.classList.add('c_tooltip')
  html.classList.add(directionClass)
  html.classList.add(sizeClass)

  let arrow = document.createElement('div')
  arrow.classList.add('tooltip-arrow')
  html.appendChild(arrow)

  let inner = document.createElement('div')
  inner.classList.add('tooltip-inner')

  let content = document.createElement('div')
  // content.style.whiteSpace = 'pre-wrap'
  content.classList.add('is-padding-small', 'content', 'is-size-6', 'has-text-grey')
  content.innerHTML = text

  inner.appendChild(content)
  html.appendChild(inner)

  return html
}

if (store && store.getters && store.getters.configs) {
  const envConf = {
    CONTENTFUL_SPACE_ID: store.getters.configs.CONTENTFUL_SPACE_ID,
    CONTENTFUL_ACCESS_TOKEN: store.getters.configs.CONTENTFUL_ACCESS_TOKEN
  }

  const contentfulClient = createClient({
    // This is the space ID. A space is like a project folder in Contentful terms
    space: envConf.CONTENTFUL_SPACE_ID,
    // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
    accessToken: envConf.CONTENTFUL_ACCESS_TOKEN
  })

  Object.defineProperty(Vue.prototype, '$contentful', {
    value: contentfulClient
  })

  Vue.directive('helper', {
    bind: (el, binding) => {
      const helperId = binding.value
      const params = binding.modifiers

      let direction = 'right'
      if (params.left) {
        direction = 'left'
      } else if (params.top) {
        direction = 'top'
      } else if (params.topLeft) {
        direction = 'topLeft'
      } else if (params.topRight) {
        direction = 'topRight'
      } else if (params.bottom) {
        direction = 'bottom'
      } else if (params.bottomRight) {
        direction = 'bottomRight'
      } else if (params.bottomLeft) {
        direction = 'bottomLeft'
      } else if (params.right) {
        direction = 'right'
      }

      let size = 'small'
      if (params.medium) {
        size = 'medium'
      } else if (params.large) {
        size = 'large'
      } else if (params.xlarge) {
        size = 'xlarge'
      }

      let tooltip = createTooltipHtml('', direction, size)
      el.appendChild(tooltip)

      let inner = tooltip.getElementsByClassName('tooltip-inner')[0]
      let content = inner.getElementsByClassName('content')[0]

      el.appendChild(tooltip)
      el.style.position = 'relative'
      el.addEventListener('mouseenter', () => {
        tooltip.classList.add('active')
      })
      el.addEventListener('mouseleave', () => {
        tooltip.classList.remove('active')
      })
      el.addEventListener('click', () => {
        tooltip.classList.toggle('active')
      })

      contentfulClient.getEntry(helperId)
        .then(entry => {
          let showdown = require('showdown')
          let converter = new showdown.Converter()
          let text = entry.fields.text
          content.innerHTML = converter.makeHtml(text)
        })
        .catch(console.error)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/HelperDirective.js